import axios from "axios"

export const getResetLink = (email) => {
    return axios.post('/users/forgotpassword/', {UserEmail: email}, {
        baseURL: window["APP_SETTINGS"].REACT_APP_TRIYO_API_URL,
    })
}

export const setNewPassword = (password, token) => {
    return axios.post("/users/resetpassword/", {Password: password}, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        baseURL: window["APP_SETTINGS"].REACT_APP_TRIYO_API_URL,
    } )
}